import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '分类导航', path: '/category/riman' },
    { label: '使用教程', path: '/article/register-guide' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '日漫精选', path: '/category/riman' },
    { label: '韩漫精选', path: '/category/hanman' },
    { label: '欧美漫画', path: '/category/oumei' },
    { label: '3D漫画', path: '/category/3d' },
    { label: '国漫精选', path: '/category/guoman' },
  ],
  articles: [
    { label: '注册教程', path: '/article/register-guide' },
    { label: '登录指南', path: '/article/login-guide' },
    { label: '访问入口', path: '/article/access-guide' },
    { label: '阅读技巧', path: '/article/reading-tips' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-800 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-base text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-white whitespace-nowrap">
                禁漫天堂
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400 mb-4">
              最受欢迎的成人漫画在线阅读平台，海量高清漫画资源，多端适配，安全私密，随时随地畅享阅读乐趣。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">帮助指南</h4>
            <ul className="space-y-2.5">
              {footerLinks.articles.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 pt-4 border-t border-background-700">
              <p className="text-xs text-foreground-500 mb-1">联系邮箱</p>
              <a href="mailto:support@jmtthub.com" className="text-sm text-foreground-300 hover:text-white transition-colors">
                support@jmtthub.com
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 禁漫天堂 版权所有 | 本站为禁漫天堂官方入口导航站
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}